import { useState, useEffect, useRef } from "react";
import { FaSpinner, FaInfoCircle } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setUserInfo } from "../utils/store/actions/userInfoAction";
import { setTimeTable } from "../utils/store/actions/timeTableAction";
import { useRouter } from "next/router";
import Link from "next/link";
import { setCookie } from "nookies";
import axios from "../utils/fetch/axiosInstance";
import useTimer from "../utils/customHook/useTimer";
import { phoneFormatter, timerFormatter } from "../utils/common/fomatter";
import {
  SEND_PHONE_NUM,
  LOGIN,
  INFO_LIST,
  SEND_ATTEND,
} from "../utils/fetch/apiConfig";
import FAQ from "../components/FAQ/FAQ";
import Exit from "../components/Exit/Exit";
import Policy from "../components/Policy/Policy";
import styles from "./index.module.scss";
import {
  setCheck,
  setIsCheckInit,
} from "../utils/store/actions/userStateAction";
import { setTimer } from "../utils/store/actions/timerActions";
import { setMediaStreamInit } from "../utils/store/actions/mediaStreamAction";

const errorMsg = "관리자에게 문의하세요.";

const Index = ({ data }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const [sendedInfo, setSendedInfo] = useState(false);
  const [time, setTime, timeStart, timeStop] = useTimer();
  const [input, setInput] = useState("");
  const [comment, setComment] = useState("");
  const [policyOpen, setPolicyOpen] = useState(false);
  const isLoading = useRef(false);

  useEffect(() => {
    // 응시자 정보 및 타임테이블, 타이머, 캠 정보 초기화
    dispatch(setUserInfo({}));
    dispatch(
      setTimer({
        startTime: "2021-01-25 10:00",
        afterTime: 0,
        timeLimit: 10800,
        start: () => {},
        stop: () => {},
      }),
    );
    dispatch(setTimeTable([]));
    dispatch(setIsCheckInit());
    dispatch(setMediaStreamInit());
  }, []);

  const checkLoginState = (res) =>
    res.data.result === "preCheckTest" ||
    res.data.result === "firstTest" ||
    res.data.result === "secondTest";

  const sendAuthNum = async () => {
    if (isLoading.current) {
      return;
    }

    try {
      isLoading.current = true;

      const res = await axios.post(LOGIN, {
        phoneNum: sendedInfo,
        confirmNo: input,
      });

      if (checkLoginState(res)) {
        dispatch(setUserInfo(res.data.Tester));
        sessionStorage.setItem("userInfo", JSON.stringify(res.data.Tester));
        dispatch(setTimeTable(res.data.TimeTable));
        sessionStorage.setItem("timeTable", JSON.stringify(res.data.TimeTable));

        axios.defaults.headers.common["token"] = res.data.token;

        //세션스토리지 토큰 추가
        sessionStorage.setItem("token", res.data.token);
        setCookie(null, "token", res.data.token, {
          path: "/",
          maxAge: 99999,
        });

        isLoading.current = false;

        if (res.data.result === "preCheckTest") {
          if (res.data.Tester.TESTER_WHICH === "Y") {
            router.push("/device?mod=test", undefined, { shallow: true });
          } else {
            router.push("/prevInfo", undefined, { shallow: true });
          }
        } else if (res.data.result === "firstTest") {
          axios.post(SEND_ATTEND);
          router.push("/device");
        } else if (res.data.result === "secondTest") {
          dispatch(setCheck(true));
          router.push("/ready");
        }
      } else {
        isLoading.current = false;
        setComment(res.data.msg);
      }
    } catch (error) {
      isLoading.current = false;
      setComment(errorMsg);
      console.error(error);
    }
  };

  const sendPhoneNum = async () => {
    if (isLoading.current) {
      return;
    }

    try {
      isLoading.current = true;

      const res = await axios.post(SEND_PHONE_NUM, {
        phoneNum: input,
      });

      if (checkLoginState(res)) {
        setSendedInfo(input);
        setComment("");
        setInput("");
        timeStart();
        isLoading.current = false;
      } else {
        isLoading.current = false;
        setComment(res.data.msg);
      }
    } catch (error) {
      isLoading.current = false;
      setComment(errorMsg);
      console.error(error);
    }
  };

  const sendInput = (e) => {
    e.preventDefault();

    if (sendedInfo) {
      sendAuthNum();
    } else {
      sendPhoneNum();
    }
  };

  useEffect(() => {
    if (time === 0) {
      setInput("");
      setSendedInfo(false);
      timeStop(true);
    }
  }, [time]);

  useEffect(() => {
    sessionStorage.removeItem("token");
  }, []);

  return (
    <div className={styles.wrap}>
      <div className={styles.login_wrap}>
        <form>
          <div className={styles.input_wrap}>
            <input
              placeholder={sendedInfo ? "인증 번호 입력" : "휴대전화 번호 입력"}
              maxLength={sendedInfo ? 6 : 13}
              value={sendedInfo ? input : phoneFormatter(input)}
              onChange={(e) => setInput(e.target.value.replace(/[^0-9]/g, ""))}
            />
            {sendedInfo && (
              <div className={styles.timer}>
                <FaSpinner className="icon-spin" />
                {timerFormatter(time)}
              </div>
            )}
            <button
              className={isLoading.current ? styles.loading_btn : ""}
              onClick={(e) => sendInput(e)}
            >
              {sendedInfo ? "로그인" : "인증번호 발송"}
              {isLoading.current && <FaSpinner className="icon-spin" />}
            </button>
          </div>
        </form>
        {comment && (
          <div className={styles.comment}>
            <FaInfoCircle />
            {comment}
          </div>
        )}
      </div>
      {policyOpen && <Policy setModalOpen={setPolicyOpen} data={data[0]} />}
      <FAQ fixed top={25} right={100} />
      <Exit fixed top={21} right={30} black />
    </div>
  );
};

export async function getStaticProps() {
  const res = await axios.post(INFO_LIST, { F_Cate: "Notice" });
  const data = res.data.data;

  return {
    props: {
      data,
    },
  };
}

export default Index;





